import { string, bool, array, object, shape, func } from 'prop-types';
import { CURRENT_USER } from '../../../../shared/propTypes/currentUser';

export const CHOOSE_VARIATION = {
    orders: array,
    savedDrafts: array,
    userSavedProject: shape({
        id: string,
        project_id: string,
        variation_id: string,
    }),
    projectData: shape({
        project: object,
        seller: object,
        variations: array,
    }),
    httpRequest: shape({
        url: string,
        referrer: string,
    }),
    ...CURRENT_USER,
};

export const MOBILE_CHOOSE_VARIATION = {
    designerVariations: array,
    orderedVariations: array,
    draftsVariations: array,
    projectIsSaved: bool,
    isProjectOwner: bool,
    onSavedProjectChange: func,
    onMainSampleRendered: func,
};

export const SAMPLES_SLIDER = {
    projectIsSaved: bool,
    onSavedProjectChange: func,
    onMainSampleRendered: func,
};
